/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { FlexColumnMax, FlexColumnLarge } from "~/components/Tables/styles";
import { DeleteEmail } from "./DeleteEmail";
import { EditEmailForm } from "./EditEmailForm";

export type Emails = {
  id: string;
  email: string;
};

const columnHelper = createColumnHelper<Emails>();

export function columns() {
  return [
    columnHelper.accessor(() => null, {
      header: "Email",
      cell: ({ row }) => <div>{row.original.email}</div>,
      meta: FlexColumnMax,
    }),
    columnHelper.accessor(() => null, {
      id: "options",
      header: () => null,
      cell: ({ row }) => {
        const { email, id } = row.original;

        return (
          <FlexContainer
            justifyContent="space-between"
            gap={theme.spacing.spacing01}
          >
            <EditEmailForm emailId={id} defaultValue={email} />
            <DeleteEmail email={email} channelId={id} />
          </FlexContainer>
        );
      },
      meta: FlexColumnLarge,
    }),
  ] as never;
}
